import styled, { css } from 'styled-components'
import { ILoadingProps } from '.'

export const ContainerLoad = styled.div<ILoadingProps>(
  ({ theme, fullScreen }) => css`
    background: ${fullScreen ? theme.colors.font.dark : 'transparent'};
    background: ${theme.colors.font.dark};
    width: 100%;
    height: 100%;

    position: ${fullScreen ? 'fixed' : 'absolute'};
    top: ${fullScreen && '0'};
    left: ${fullScreen && '0'};

    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99997;
  `
)
